import { parseApiResponse, throwApiError } from '@/shared/utils/apiResponse';
import { apiGet, apiPost } from '@/shared/utils/requestBuilder';

import type {
  PorteiroDetalheResposta,
  PorteiroRevisaoPedido,
} from '../../types/porteiroObservabilidade';

const rotaDaAvaliacao = (avaliacaoId: string) =>
  `/admin/platform/porteiro/avaliacoes/${encodeURIComponent(avaliacaoId)}`;

export const porteiroAvaliacaoService = {
  async detalhe(avaliacaoId: string, signal?: AbortSignal): Promise<PorteiroDetalheResposta> {
    const response = await apiGet(rotaDaAvaliacao(avaliacaoId), undefined, false, signal);
    if (!response.ok) await throwApiError(response, 'Erro ao carregar a trilha da avaliação');
    return parseApiResponse<PorteiroDetalheResposta>(response);
  },

  /** A resposta é o detalhe já revisado: a tela troca a trilha sem uma segunda leitura. */
  async revisar({
    avaliacaoId,
    ...pedido
  }: PorteiroRevisaoPedido): Promise<PorteiroDetalheResposta> {
    const response = await apiPost(`${rotaDaAvaliacao(avaliacaoId)}/revisao`, pedido);
    if (!response.ok) await throwApiError(response, 'Erro ao registrar a revisão da suspeita');
    return parseApiResponse<PorteiroDetalheResposta>(response);
  },
};
